import { obterEntradasNFAsync } from "../../services/entradaNFService";

const atualizarEntradasNF = async ({ commit }) => {
    const entradasNF = await obterEntradasNFAsync();
    commit('atualizarEntradasNF', entradasNF);
}

const atualizarEntradaNF = ({ commit }, entradaNF) => {
    commit('atualizarEntradaNF', entradaNF);
}

const atualizarPedidosNF = ({ commit }, pedidosNF) => {
    commit('atualizarPedidosNF', pedidosNF);
}
const updateEntradaNF = ({ commit }, entradaNF) => {
    commit('updateEntradaNF', entradaNF);
}

export default {
    atualizarEntradasNF,
    atualizarEntradaNF,
    atualizarPedidosNF,
    updateEntradaNF
}